import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsDrugApi,
	searchsDrugApiBy
} from 'interface/endpoints'
import {
	SearchsDrugFormData,
  SearchsDrugResult,
  SearchsDrugResultList
} from './types'

export * from './types'

export const useListSearchsDrug = (
  searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId) return null
      return ApiGetWithToken<SearchsDrugResultList>(
        apiAccess,
        searchsDrugApi(searchId, "/list"),
        cancelToken
  		)
    },
		[searchId]
	)
)

export const useGetSearchsDrug = (
  searchId?: number | null,
	searchsDrugId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId || !searchsDrugId) return null
      return ApiGetWithToken<SearchsDrugResult>(
        apiAccess,
        searchsDrugApiBy(searchId, searchsDrugId),
        cancelToken
  		)
    },
		[searchId, searchsDrugId]
	)
)

export const usePostSearchsDrug = (
	searchId: number, 
  callback?: {
    onPosted?: (result: SearchsDrugResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsDrugFormData, SearchsDrugResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsDrugApi(searchId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditSearchsDrug = (
  searchId: number,
	searchsDrugId: number, 
	callback?: {
    onEditted?: (result: SearchsDrugResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsDrugFormData, SearchsDrugResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsDrugApiBy(searchId, searchsDrugId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, searchsDrugId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useSortSearchsDrug = (
  searchId: number, 
	callback?: {
    onPosted?: (result: SearchsDrugResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number[], SearchsDrugResult>(
	useCallback(
		(apiAccess, cancelToken, ids, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsDrugApi(searchId, "/sort"),
				ids,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useRemoveSearchsDrug = (
  searchId: number, 
	callback?: {
    onDeleted?: (searchsDrugId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, searchsDrugId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsDrugApiBy(searchId, searchsDrugId),
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
